<template>
  <div class="info-page">
    <crumbs title="消息提醒" />
    <el-form
      :model="form"
      :rules="rules"
      ref="ruleForm"
      label-position="right"
      label-width="auto"
    >
      <div class="info-page__item">
        <div class="info-page__title">
          <span>推送目标</span>
        </div>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="全站推送" prop="isAllSubscriber">
              <el-switch
                v-model="form.isAllSubscriber"
                :active-value="1"
                :inactive-value="0"
                @change="form.userList = []"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <template v-if="form.isAllSubscriber === 0">
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item label="选择用户" prop="userList">
                <div class="selected-user">
                  <span v-for="item in form.userList" :key="item.id">{{
                    item.account
                  }}</span>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item>
                <notification-user-search
                  :multipleSelection.sync="form.userList"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </template>
      </div>
      <div class="info-page__item">
        <div class="info-page__title">
          <span>推送信息</span>
        </div>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="标题" prop="title">
              <el-input
                v-model="form.title"
                placeholder="请输入标题"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="内容" prop="content">
              <el-input
                v-model="form.content"
                type="textarea"
                :autosize="{ minRows: 3 }"
                placeholder="请输入要发送的内容"
                maxlength="2000"
                show-word-limit
                resize="none"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>

    <div class="submit fn-text-center mt-20">
      <el-button
        type="primary"
        :loading="isLoading"
        plain
        @click="handlerAddData('ruleForm')"
        >提交</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "notificationInfo",
  data() {
    const isEmpty = (
      message = "该项值不能为空",
      trigger = ["blur", "change"]
    ) => {
      return {
        required: true,
        message,
        trigger
      };
    };
    return {
      // 是否处于loading状态
      isLoading: false,
      //是添加数据还是修改数据
      isAdd: true,
      //表单
      form: {
        isAllSubscriber: 1,
        userList: [],
        title: "",
        content: ""
      },
      rules: {
        isAllSubscriber: [isEmpty("请选择是否全站推送", "change")],
        userList: [isEmpty("请选择用户", "change")],
        title: [isEmpty("请输入标题")],
        content: [isEmpty("请输入要发送的内容")]
      }
    };
  },
  created() {},
  methods: {
    // 正向处理数据 将数据处理后提交
    processDataSubmit() {
      const {
        // list
        userList,
        ...others
      } = this.form;
      const userId = userList.map((item) => item.id);
      return {
        ...others,
        userId
      };
    },
    // 点击添加数据按钮
    handlerAddData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadAddData();
        }
      });
    },
    // 加载添加数据接口
    loadAddData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      this.$api("system", "addNotification", params).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },
    // 返回列表页
    redirectTo() {
      // this.redirectByPath(`/admin/systemManage/notificationList`);
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped>
.info-page {
  .selected-user {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    height: 40px;
    padding: 0 15px;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    span {
      box-sizing: border-box;
      height: 24px;
      padding: 0 8px;
      margin-right: 10px;
      border: 1px solid #e9e9eb;
      border-radius: 4px;
      line-height: 22px;
      color: #909399;
      font-size: 12px;
      background-color: #f4f4f5;
    }
  }
}
</style>
